import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function PickupAttachmentsDetails({
    label,
    options,
    attachments,
    onChange,
    isEditable,
    pickupName,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={options}
                selectedValue={attachments}
                onSave={onChange}
                isEditable={isEditable}
                pickupName={pickupName}
            />
        </EuiFlexItem>
    );
}
